import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { isApiConfigured } from '../../api/axiosClient';
import apiClient from '../../api/axiosClient';
import { useToast } from '../../components/Toast';
import { authApi } from '../../api/authApi';
import { Turnstile } from '../../components/Turnstile';
import { LoadingSpinner } from '../../components/LoadingSpinner';

const AnimInput = ({ label, hint, icon, type = 'text', value, onChange }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: focused ? '#0D9488' : '#6B7280', transition: 'color 0.2s', marginBottom: 8 }}>{label}</div>
      <div style={{
        background: focused ? 'rgba(13,148,136,0.03)' : '#F8FAFB',
        border: `${focused ? 1.5 : 1}px solid ${focused ? '#0D9488' : '#E8ECF0'}`,
        borderRadius: 14, display: 'flex', alignItems: 'center', padding: '0 14px',
        boxShadow: focused ? '0 4px 12px rgba(13,148,136,0.08)' : 'none',
        transition: 'all 0.2s',
      }}>
        <span style={{ fontSize: 18, marginRight: 10, opacity: focused ? 1 : 0.5, transition: 'opacity 0.2s' }}>{icon}</span>
        <input
          type={type}
          placeholder={hint}
          value={value}
          onChange={e => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={{ border: 'none', outline: 'none', padding: '16px 0', fontSize: 15, width: '100%', background: 'transparent', color: '#1A1D21', fontFamily: 'inherit' }}
        />
      </div>
    </div>
  );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(255,255,255,0.7)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};

const ForgotPasswordPage = () => {
    const toast = useToast();
    const turnstileRef = useRef(null);//
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState(null);

    //useEffect(() => {

    //    setPageLoading(true);
    //    if (turnstileToken != null) {
    //        setPageLoading(false);
    //    }

    //}, [turnstileToken]);

    useEffect(() => {

        if (
            turnstileToken &&
            typeof turnstileToken === 'string' &&
            turnstileToken.trim() !== ''
        ) {

            setPageLoading(false);

        } else {

            setPageLoading(true);
        }

    }, [turnstileToken]);

    const handleSubmit = async () => {
      
    setError('');
    if (!email) {
      setError('Please enter your email address.');
      return;
    }
        
        if (turnstileToken == null || turnstileToken=="") {            
            location.reload();
            return;
        }

        
    setLoading(true);
    try {
        if (isApiConfigured())
        {
        
            var res = await apiClient.post('/api/provider/auth/forgot-password', { userEmail: email, turnstileToken: turnstileToken });
            
          if (res.data.Success) {
              setSent(true);
              toast.success("Password reset link sent to your email", { title: 'Forgot Password' });
          }
          else
          {
              

              //toast.error(res.data.Message, { title: 'Forgot Password' });

              setError(res.data.Message);

              // clear old token
              setTurnstileToken(null);

              // generate fresh token
              
              turnstileRef.current?.reset();
          }
            setLoading(false);
      }
      
    }
    catch
    {     

        setError('Unable to send reset link. Please try again.');

        // clear old token
        setTurnstileToken(null);

        // generate fresh token
        turnstileRef.current?.reset();

        setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="auth-layout">
          {pageLoading && (
              <div style={styles.overlay}>
                  <LoadingSpinner message="Please wait..." fullPage="true" />
              </div>
          )}
      {/* Gradient header */}
      <div style={{
        background: 'linear-gradient(135deg, #0F766E, #14B8A6, #2DD4BF)',
        padding: '40px 0 30px', borderRadius: '0 0 36px 36px',
        textAlign: 'center', width: '100%', maxWidth: 440,
        boxShadow: '0 10px 30px rgba(13,148,136,0.3)',
        marginBottom: -20, zIndex: 2, position: 'relative'
      }}>
        <div style={{ width: 56, height: 56, borderRadius: 18, background: '#fff', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, boxShadow: '0 6px 20px rgba(0,0,0,0.1)' }}>
          {'\u{1F511}'}
        </div>
        <div style={{ fontSize: 24, fontWeight: 800, color: '#fff', marginTop: 16, letterSpacing: -0.5 }}>Reset Password</div>
        <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.8)', marginTop: 4 }}>Enter your email to receive a reset link</div>
      </div>

      {/* Card */}
      <div className="auth-card" style={{ paddingTop: 36, position: 'relative', zIndex: 1 }}>
        {!sent ? (
          <>
            {error && <div className="error-text" style={{ marginBottom: 16 }}>{error}</div>}

            <AnimInput label="Email Address" hint="Enter your email" icon={'\u2709\uFE0F'} type="email" value={email} onChange={setEmail} />

            {/* Send Reset Link Button */}
            <div
              onClick={handleSubmit}
              style={{
                width: '100%', height: 52, borderRadius: 14, cursor: 'pointer',
                background: 'linear-gradient(135deg, #0D9488, #0F766E)',
                boxShadow: '0 6px 16px rgba(13,148,136,0.3)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'transform 0.1s', userSelect: 'none',
              }}
              onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.97)')}
              onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
            >
              {loading ? (
                <div style={{ width: 22, height: 22, border: '2.5px solid rgba(255,255,255,0.4)', borderTop: '2.5px solid #fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
              ) : (
                <span style={{ fontSize: 16, fontWeight: 700, color: '#fff', letterSpacing: 0.3 }}>Send Reset Link</span>
              )}
            </div>

            <div style={{ textAlign: 'center', marginTop: 28, fontSize: 14, color: '#6B7280' }}>
              Remember your password? <Link to="/login" style={{ color: '#0D9488', fontWeight: 700 }}>Sign In</Link>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            {/* Green checkmark icon */}
            <div style={{
              width: 64, height: 64, borderRadius: '50%',
              background: 'linear-gradient(135deg, #10B981, #059669)',
              margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 6px 20px rgba(16,185,129,0.3)',
            }}>
              <span style={{ color: '#fff', fontSize: 30, fontWeight: 700 }}>{'\u2713'}</span>
            </div>

            <div style={{ fontSize: 22, fontWeight: 800, color: '#1A1D21', marginTop: 24, letterSpacing: -0.3 }}>Check Your Email</div>
            <div style={{ fontSize: 14, color: '#6B7280', marginTop: 12, lineHeight: 1.6, padding: '0 10px' }}>
              We've sent a password reset link to <span style={{ fontWeight: 600, color: '#0D9488' }}>{email}</span>. Check your inbox and follow the instructions.
            </div>

            {/* Back to Login Button */}
            <div
              onClick={() => navigate('/login')}
              style={{
                width: '100%', height: 52, borderRadius: 14, cursor: 'pointer',
                background: 'linear-gradient(135deg, #0D9488, #0F766E)',
                boxShadow: '0 6px 16px rgba(13,148,136,0.3)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'transform 0.1s', userSelect: 'none', marginTop: 32,
              }}
              onMouseDown={e => (e.currentTarget.style.transform = 'scale(0.97)')}
              onMouseUp={e => (e.currentTarget.style.transform = 'scale(1)')}
              onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
            >
              <span style={{ fontSize: 16, fontWeight: 700, color: '#fff', letterSpacing: 0.3 }}>Back to Login</span>
            </div>
          </div>
              )}

              
          </div>

          {/* Cloudflare Turnstile - invisible bot protection */}
          <Turnstile onVerify={setTurnstileToken} ref={turnstileRef} />

      <div className="auth-footer-links">
        <a href="/terms">Terms of Service</a>
        <a href="/privacy">Privacy Policy</a>
        <a href="/contact-us">Contact</a>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
